module.exports = {
      id: "docs-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#docs-usage",
      toString: function () {
        return this.url;
      }
    }